import { useState } from 'react';
import {
  Box,
  Container,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Divider,
} from '@mui/material';
import { YesNoNASelector } from './Table/YesNoNASelector';


const FormulationPrePostAudi = ({ modificar = {}, onSave}) => {
  const timestamp = new Date().toLocaleString(); 
  const [form, setForm] = useState({
    FistName: '',
    LastName: '',
    BillingServiceDate: '',
    PhysicianIndicated: '',
    AllProceduresBilled: '',
    ProgressNotesAre: '',
    DateOfVisit: '',
    ReasonForVisit: '',
    VitalSignsClearly: '', 
    PainAssessment: '',
    DiagnosisClearly: '',
    Treatment: '',
    AreAllEntriesSigned: '',
    AreAllergiesAndAdverse: '',
    AreLabAndDiagnosticStudies: '',
    TimeStamp:''
  });

    const handleChange = (field, value) => {
        setForm(prev => ({ ...prev, [field]: value }));
    };

    const handleSubmit = () => {
        const newSystemicBilling = {
        ...form
        };
        onSave(newSystemicBilling);
        setForm({
        FistName: '',
        LastName: '',
        BillingServiceDate: '',
        PhysicianIndicated: '',
        AllProceduresBilled: '',
        ProgressNotesAre: '',
        DateOfVisit: '',
        ReasonForVisit: '',
        VitalSignsClearly: '', 
        PainAssessment: '',
        DiagnosisClearly: '',
        Treatment: '',
        AreAllEntriesSigned: '',
        AreAllergiesAndAdverse: '',
        AreLabAndDiagnosticStudies: '',
        TimeStamp:''
        });
    };

  return (
    <Container maxWidth="xl">
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">AHCA Form</Typography>
      </Box>
      <Paper variant="outlined" sx={{ p: 4, mb: 3 }}>
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Systemic Billing Review</Typography>
        <Divider sx={{ mb: 2 }} />
        <Grid container spacing={2}>
        <Grid item width="100%"><Typography><strong>Fist Name</strong></Typography></Grid>
          <TextField
            fullWidth
            value={form.FistName}
            onChange={e => handleChange('FistName', e.target.value)}
          />
        <Grid item width="100%"><Typography><strong>Last Name</strong></Typography></Grid>
        <TextField
            fullWidth
            value={form.LastName}
            onChange={e => handleChange('LastName', e.target.value)}
        />

        <Grid item width="100%"><Typography><strong>Billing Service date</strong></Typography></Grid>
        <TextField
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.BillingServiceDate}
            onChange={e => handleChange('BillingServiceDate', e.target.value)}
        />

        <YesNoNASelector width="100%"
            label="1. Physician indicated procedures performed in medical record"
            name="PhysicianIndicated"
            value={form.PhysicianIndicated}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="2. All procedures billed on 1500 form are documented in chart"
            name="AllProceduresBilled"
            value={form.AllProceduresBilled}
            onChange={(name, option) =>handleChange(name, option)}
        />
        
        <Divider sx={{ mb: 2 }} />
        <Typography variant="subtitle1" fontWeight="bold" gutterBottom>Clinical Chart</Typography>
        <YesNoNASelector width="100%"
            label="Progress notes are legible and include"
            name="ProgressNotesAre"
            value={form.ProgressNotesAre}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <Grid item width="100%"><Typography><strong>1. Date of visit</strong></Typography></Grid>
        <TextField
            type="date"
            fullWidth
            InputLabelProps={{ shrink: true }}
            value={form.DateOfVisit}
            onChange={e => handleChange('DateOfVisit', e.target.value)}
        />
        <Grid item width="100%"><Typography><strong>2. Reason for visit</strong></Typography></Grid>
          <TextField
            fullWidth
            value={form.ReasonForVisit}
            onChange={e => handleChange('ReasonForVisit', e.target.value)}
          />
        <YesNoNASelector
            label="3. vital Signs Clearly Noted"
            name="VitalSignsClearly"
            value={form.VitalSignsClearly}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="4. Pain Assessment"
            name="PainAssessment"
            value={form.PainAssessment}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="5. Diagnosis Clearly Stated"
            name="DiagnosisClearly"
            value={form.DiagnosisClearly}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="6. Treatment"
            name="Treatment"
            value={form.Treatment}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="7. Are All entries signed and dated"
            name="AreAllEntriesSigned"
            value={form.AreAllEntriesSigned}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="8. Are allergies and adverse reactions noted and flagged"
            name="AreAllergiesAndAdverse"
            value={form.AreAllergiesAndAdverse}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <YesNoNASelector
            label="8. Are Lab and diagnostic studies orderd and filed appropriately"
            name="AreLabAndDiagnosticStudies"
            value={form.AreLabAndDiagnosticStudies}
            onChange={(name, option) =>handleChange(name, option)}
        />
        <TextField
            fullWidth
            value={timestamp}
            disabled
          />
        </Grid>
        
        <Button 
            fullWidth
            variant="contained"
            sx={{ 
                mt: 2, // espacio arriba (theme spacing * 2 = 16px)
                backgroundColor: '#bdbdbd',
                color: 'black',
                '&:hover': { backgroundColor: '#9e9e9e' }
            }}
            onClick={handleSubmit}
            >
            <Typography sx={{ color: '#117a65' }}>Save</Typography>
        </Button>
      </Paper>
    </Container>
  );
};

export default FormulationPrePostAudi;
